import { createSlice } from '@reduxjs/toolkit';

export const merchantSlice = createSlice({
  name: 'merchant',
  initialState: {},
  reducers: {}
});

// Actions
export const { addMerchant, updateMerchant, deleteMerchant } = merchantSlice.actions;

export default merchantSlice.reducer;
